module.exports = __webpack_public_path__ + "static/img/role.fd24a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/kr/role.png
// module id = zQ7l
// module chunks = 7